<template>
    <f7-page bg-color="white" name="maintenance" @page:afterin="afterin">
        <f7-block>
            <div @click="checkStatus();">
            <div><img :src="require('@/assets/img/icon/maintenance-icon.svg')" style="height:300px; bottom: 0px; width: 100%;" /></div>
            <h2 class="error-title text-align-center">{{$t('maintenance-title')}}</h2>
            <div class="text-color-gray text-align-center padding" v-html="$t('maintenance-desc')"></div>
            <!-- <div class="text-color-gray text-align-center padding">{{errorCode}}</div> -->

            <!-- <div class="footer w-100">
                <f7-button large fill round color="primary" class="margin" id="btnOK"  @click="checkStatus">
                    {{$t('label-common-close')}}
                </f7-button>
            </div> -->
            </div>
        </f7-block>
    </f7-page>
</template>

<style scoped>
.error-title {
    font-weight: bold;
    font-size: 24px;
    line-height: 30px;
}
.maintenanceLogo {
    /*background: url('../assets/img/icon/maintenance-icon.svg');
    background-repeat: no-repeat;
    background-position: center;
    height: 42px; */
    display: block;
    bottom: 0px;
    background-size: 240px;
    width: 100%;
    height: 300px;
}
</style>

<script>
import { mapGetters } from "vuex";
export default {
    name: 'Maintenance',
    props: {
        errorCode: String
    },
    mounted (){
      if (this.$f7.device.desktop) {
        this.checkStatus();
      } else {
        this.checkStatusTimer();
      }
    },
    data() {
        return {
            checkTimer            : null
        }
    },
    computed: {
        ...mapGetters('auth', ['maintenanceMode']),
        ...mapGetters('registration', ['isAxsr']),
    },
    methods: {
        afterin(){
            window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
        },
        async checkStatus(){
            await this.$api.misc.ping();
            // console.log("maintenanceMode "+ this.maintenanceMode)
            if (!this.maintenanceMode) {
                if (this.checkTimer) {
                    clearInterval(this.checkTimer);
                }
                
                if(!this.isAxsr){
                    this.$f7router.navigate("/",{force: true})
                }else{
                    //this.$f7router.navigate("/axsr-login",{force: true})
                }
            }
        },

        checkStatusTimer(){
            const self = this;
            this.checkTimer = setInterval(function(){ self.checkStatus(); }, 10000);
        }
    }
};
</script>